/* A collection page's guide: subsections of prose in a readable column,
   two columns from 1024 px. */
.parts {
  display: grid;
  gap: 26px;
  max-width: 1080px;
}

.part {
  margin: 0;
}

.heading {
  margin: 0 0 10px;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 24px;
  line-height: 1.1;
}

.text {
  margin: 0 0 10px;
  font-size: 14px;
  line-height: 1.7;
  color: var(--text-secondary);
}

.text:last-child {
  margin-bottom: 0;
}

@media (min-width: 1024px) {
  .parts {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 34px 48px;
  }

  .heading {
    font-size: 27px;
  }

  .text {
    font-size: 15px;
  }
}

/* TopicLinks: "See also" pills between the intro and the cards. */
.topics {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 10px;
  margin: -12px 0 26px;
  font-size: 14px;
}

.topicsLabel {
  color: var(--text-muted);
}

.topic {
  padding: 6px 14px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-pill);
  color: var(--text);
  text-decoration: none;
}

.topic:hover {
  border-color: var(--primary);
  color: var(--primary);
}
